import { gql } from '@apollo/client';

const deleteSystemProvider = gql`
  mutation DeleteSystemProvider($id: Int!) {
    deleteSystemProvider(id: $id)
  }
`;
export default deleteSystemProvider;
